//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';
import styled from 'styled-components';

import Text from '@components/atoms/text/Text';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';
import { Mixins } from '@theme/mixins';

export const StreamSourceLabel = ({ labelText }: { labelText: string }) => {
  return <SourceLabel mixin={Mixins.Text.Metatag}>{labelText}</SourceLabel>;
};

const SourceLabel = styled(Text)(
  ({ theme }) => `
  color: ${theme.colors.white};
`,
);

angular.module('curalate').component('streamSourceLabel', {
  bindings: {
    labelText: '<',
  },
  controller: makeAngularReactControllerWithScope(
    ({
      $ctrl,
    }: {
      $ctrl: {
        labelText: string;
      };
    }) => {
      return <StreamSourceLabel labelText={$ctrl.labelText} />;
    },
  ),
});
